export enum InspectionAction {
    OPT_IN = 'OPT_IN',
    OPT_OUT = 'OPT_OUT',
    CANCEL = 'CANCEL',
}
